module.exports = __webpack_public_path__ + "media/images/daohouse-friends/bg-800e0f5581cfeaa59526df84567b97ed.svg";